// Pipeline actions
export const RECEIVE_PIPELINE = 'RECEIVE_PIPELINE';
export const EXPORT_AND_SAVE_PIPELINE = 'EXPORT_AND_SAVE_PIPELINE';
export const HANDLE_PIPELINE_ERROR = 'HANDLE_PIPELINE_ERROR';

// Pipeline Pagination actions
export const PAGINATE_PIPELINE = 'PAGINATE_PIPELINE';

// Latest Approvals Actions
export const RECEIVE_LEADS = 'RECEIVE_LEADS';
export const HANDLE_LEADS_ERROR = 'HANDLE_LEADS_ERROR';

// Latest Approvals Actions
export const RECEIVE_LATEST_APPROVALS = 'RECEIVE_LATEST_APPROVALS';
export const HANDLE_LATEST_APPROVALS_ERROR = 'HANDLE_LATEST_APPROVALS_ERROR';

// Latest Contracts Actions
export const RECEIVE_LATEST_CONTRACTS = 'RECEIVE_LATEST_CONTRACTS';
export const HANDLE_LATEST_CONTRACTS_ERROR = 'HANDLE_LATEST_CONTRACTS_ERROR';

// Portfolio actions
export const RECEIVE_PORTFOLIO = 'RECEIVE_PORTFOLIO';
export const EXPORT_AND_SAVE_PORTFOLIO = 'EXPORT_AND_SAVE_PORTFOLIO';
export const HANDLE_PORTFOLIO_ERROR = 'HANDLE_PORTFOLIO_ERROR';

// Pipeline Pagination actions
export const PAGINATE_PORTFOLIO = 'PAGINATE_PORTFOLIO';

// Homepage Actions
export const FETCH_KPI_DATA = 'FETCH_KPI_DATA';
export const RECEIVE_KPI_DATA = 'RECEIVE_KPI_DATA';

export const SET_MTD = 'SET_MTD';

export const SET_SUBMISSIONS_TYPE = 'SET_SUBMISSIONS_TYPE';

export const SET_CHART_DATA_TYPE = 'SET_CHART_DATA_TYPE';

// New Submission actions
export const SET_SUBMISSION_INFO_FORM_SECTION_DATA = 'SET_SUBMISSION_INFO_FORM_SECTION_DATA';
export const SET_FILES_TO_BE_UPLOADED = 'SET_FILES_TO_BE_UPLOADED';
export const SET_FAILED_FILES = 'SET_FAILED_FILES';

export const POST_SUBMISSION_INFO = 'POST_SUBMISSION_INFO';
export const CONFIRM_SUBMISSION_INFO = 'CONFIRM_SUBMISSION_INFO';
export const SUBMISSION_INFO_LOADING = 'SUBMISSION_INFO_LOADING';

export const POST_SUBMISSION_ATTACHMENTS = 'POST_SUBMISSION_ATTACHMENTS';
export const CONFIRM_SUBMISSION_ATTACHMENTS = 'CONFIRM_SUBMISSION_ATTACHMENTS';
export const CLEAR_SUBMISSION_ATTACHMENTS = 'CLEAR_SUBMISSION_ATTACHMENTS';

// User actions
export const FETCH_USER_DATA = 'FETCH_USER_DATA';
export const RECEIVE_USER_DATA = 'RECEIVE_USER_DATA';
export const CLEAR_USER_DATA = 'CLEAR_USER_DATA';

// Partner Actions

export const FETCH_PARTNERS = 'FETCH_PARTNERS';
export const SELECT_PARTNER = 'SELECT_PARTNER';
export const RECEIVE_PARTNERS = 'RECEIVE_PARTNERS';
export const RECEIVE_PARTNER = 'RECEIVE_PARTNER';

// Stips Actions
export const FETCH_REQUESTED_STIPS = 'FETCH_REQUESTED_STIPS';
export const RECEIVE_REQUESTED_STIPS = 'RECEIVE_REQUESTED_STIPS';
export const SET_STIP_FILE_TAG = 'SET_STIP_FILE_TAG';
export const SET_STIP_FILE_DESCRIPTION = 'SET_STIP_FILE_DESCRIPTION';
export const SET_STIP_FILE_OWNER = 'SET_STIP_FILE_OWNER';
export const SET_STIP_FILE_EXPIRATION = 'SET_STIP_FILE_EXPIRATION';
export const RECEIVE_SUBMISSION_OWNERS = 'RECEIVE_SUBMISSION_OWNERS';

// Contact Actions
export const FETCH_CONTACTS = 'FETCH_CONTACTS';

// Google Places API Actions
export const SET_UUID = 'SET_UUID';

// Header Nav Toolbar Items Actions
export const SET_NAV_TOOLBAR_ITEMS = 'SET_NAV_TOOLBAR_ITEMS';
export const CLEAR_NAV_TOOLBAR_ITEMS = 'CLEAR_NAV_TOOLBAR_ITEMS';

export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

// Merchant actions
export const RECEIVE_MERCHANTS = 'RECEIVE_MERCHANTS';
export const FETCH_MERCHANTS = 'FETCH_MERCHANTS';
